import { render, staticRenderFns } from "./ontick-success.component.vue?vue&type=template&id=970a6c5e&scoped=true"
import script from "./ontick-success.component.vue?vue&type=script&lang=js"
export * from "./ontick-success.component.vue?vue&type=script&lang=js"
import style0 from "./ontick-success.component.vue?vue&type=style&index=0&id=970a6c5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "970a6c5e",
  null
  
)

export default component.exports